import React from "react";
import { getString } from "../utils/localizationHelper";

const ReviseAnswers = ({ editPreferences }) => {
  return (
    <div className="revise-answers">
      <h4>{getString("results.footer")}</h4>
      <button className="tf-btn tf-btn-primary" onClick={editPreferences}>
        {getString("results.footer.cta")}
      </button>
    </div>
  );
};

export default ReviseAnswers;
